import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import SearchBar from 'pf9-ui-components/built/components/SearchBar'
import AsyncDropdown from 'pf9-ui-components/built/elements/dropdown/AsyncDropdown'
import React from 'react'

const useStyles = makeStyles(() => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: '32px',
  },
  filters: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifySelf: 'start',
  },
  controls: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'baseline',
    gap: '16px',
    justifySelf: 'end',
  },
}))

interface Props {
  filters?: JSX.Element
  showSortOption?: boolean
  sortOptions?: {
    key?: string | number
    value: unknown | '__all__' | '__none__'
    label?: string
    content?: React.ReactNode
    disabled?: boolean
  }[]
  onSortChange?: (value) => void
  sortBy?: string
  searchTerm: string
  onSearchChange: (value) => unknown
  className?: string
}

export default function FilterToolbar({
  filters,
  showSortOption = false,
  sortOptions = [],
  onSortChange,
  sortBy,
  searchTerm,
  onSearchChange,
  className,
}: Props) {
  const classes = useStyles()
  return (
    <div className={clsx(classes.toolbar, className)}>
      <div className={clsx(classes.controls, 'controls')}>
        <SearchBar searchTerm={searchTerm} onSearchChange={onSearchChange} />
      </div>
      <div className={clsx(classes.filters, 'filters')}>
        {filters}
        {showSortOption && (
          <AsyncDropdown
            onChange={onSortChange}
            items={sortOptions}
            value={sortBy}
            name="sort"
            label="Sort"
            showAll={false}
            compact
            selectFirst
          />
        )}
      </div>
    </div>
  )
}
